import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { withTheme } from 'styled-components';
import { ActionCableConsumer, Layout } from '@jjj/components';
import appActions from '../../redux/app/actions';
import TopbarUser from './topbarUser/topbarUser';
import OrgSwitcher from './orgSwitcher';
import TopbarWrapper, { LogoPlaceholder } from './topbar.style';
import { getWsUrl } from '../../settings';
import { getAuthData } from '../../helpers/auth';
import TopbarNotification from './topbarNotification';
import TopbarCountry from './TopbarCountry/topbarCountry';
import { leftNavOrgIconClickedGAEvent } from '../../helpers/googleAnalytics/events';
import { getHomePageForRole } from '../../helpers/utility';

const { Header } = Layout;

const Topbar = ({
  theme: { assets },
  toggleCollapsed,
  setUnreadNotificationsCount,
  locale = 'en',
  collapsed,
  isUnifiedLoginEnabled,
}) => {
  const isCollapsed = collapsed;

  const styling = {
    position: 'fixed',
    width: '100%',
    height: 40,
  };

  const auth = getAuthData() || {};
  const wsUrl = getWsUrl();
  const authToken = auth?.authToken;

  const handleSetUnreadNotificationsCount = response => {
    if (response && !response.error_message) {
      setUnreadNotificationsCount(response.data);
    }
  };

  const homeLink = getHomePageForRole(auth.role).link;

  return (
    <ActionCableConsumer
      url={authToken ? `${wsUrl}?auth_token=${authToken}` : wsUrl}
      channel="Notifications::NewCountsChannel"
      onReceived={handleSetUnreadNotificationsCount}
    >
      <TopbarWrapper>
        <Header style={styling} className={cx('isomorphicTopbar', { collapsed: isCollapsed })}>
          <div className="isoLeft">
            <button
              type="button"
              className={isCollapsed ? 'triggerBtn menuCollapsed' : 'triggerBtn menuOpen'}
              onClick={toggleCollapsed}
              data-cy="topbar-collapse-button"
            />
            {assets.sidebarLogo ? (
              <Link
                to={homeLink}
                className="brand-logo-link"
                onClick={leftNavOrgIconClickedGAEvent}
                data-cy="topbar-logo-link"
              >
                <img src={assets.sidebarLogo} alt="logo" className="brand-logo brand-logo-full" data-cy="topbar-logo" />
                <img
                  src={assets.sidebarCollapsedLogo}
                  alt="logo"
                  className="brand-logo brand-logo-collapsed"
                  data-cy="topbar-logo-collapsed"
                />
              </Link>
            ) : (
              <LogoPlaceholder href={homeLink} onClick={leftNavOrgIconClickedGAEvent} data-cy="topbar-logo">
                Logo
              </LogoPlaceholder>
            )}
          </div>

          <ul className="isoRight">
            <li className="isoNotify">
              <TopbarCountry />
            </li>
            <li className="isoNotify">
              <TopbarNotification locale={locale} />
            </li>
            <li className="isoUser">{isUnifiedLoginEnabled ? <OrgSwitcher /> : <TopbarUser />}</li>
          </ul>
        </Header>
      </TopbarWrapper>
    </ActionCableConsumer>
  );
};

export { Topbar };
export default connect(
  state => ({
    ...state.App,
    isUnifiedLoginEnabled: state.FeatureFlags?.flags?.unified_login_enabled ?? false,
  }),
  dispatch => ({
    toggleCollapsed: /* istanbul ignore next */ () => dispatch(appActions.toggleCollapsed()),
    setUnreadNotificationsCount: /* istanbul ignore next */ data =>
      dispatch(appActions.getUnreadNotificationsCountSuccess(data)),
  }),
)(withTheme(Topbar));
